/* apps/viewer/src/app/history-switch/history-switch.component.scss */
:host {
  margin-right: 5px;
}
/*# sourceMappingURL=history-switch.component.css.map */
